/**
 * Quand proposer la newsletter, et quand se taire.
 *
 * Séparé du composant pour être testable seul — c'est une règle, pas une vue,
 * et c'est elle qui décide si un parent voit une invitation ou rien.
 */

/** Au-delà, on peut reproposer : une saison a passé, l'envie a pu changer. */
export const MOIS_AVANT_DE_REPROPOSER = 6;

/**
 * Faut-il proposer la newsletter à ce parent ?
 *
 * Trois conditions, et la troisième est celle qui évite le harcèlement : on ne
 * repropose qu'après plusieurs mois.
 */
export function fautProposerLaNewsletter(
  profil: { newsletter?: boolean | null; newsletter_proposee_le?: string | null } | null | undefined,
  riensAFaire: boolean,
  maintenant = new Date(),
): boolean {
  if (!profil) return false;
  if (profil.newsletter) return false;
  if (!riensAFaire) return false;

  const proposee = profil.newsletter_proposee_le;
  if (!proposee) return true;

  const date = new Date(proposee);
  if (Number.isNaN(date.getTime())) return true;

  const seuil = new Date(maintenant);
  seuil.setMonth(seuil.getMonth() - MOIS_AVANT_DE_REPROPOSER);
  return date < seuil;
}
